import { memo } from "react";
import { createPortal } from "react-dom";
import { usePortalProvider } from "./contexts.js";
const Portal = memo(({ children, to }) => {
  const portalContainer = usePortalProvider();
  return createPortal(children, to ?? portalContainer);
});
Portal.displayName = "Interface.Portal";
export {
  Portal
};
//# sourceMappingURL=Portal.js.map
